import { useCallback } from 'react';
import { useDlogEvent } from 'spectacle-ui-game-bridge-react';

export type LoginFunnelPhase = 'ATT_Prompt' | 'CDNI_Screen_Error' | 'CDNI_Screen_Finish' | 'CDNI_Screen_Start' | 'EULA' | 'Game_Lobby' | 'Initializing_Screen' | 'Legal_URLs' | 'Link_Acct_Prompt' | 'Link_Acct_Prompt_Confirm_Continue_Guest' | 'Login_Guest_Creation_Screen' | 'Login_Popup' | 'Login_Screen' | 'Login_Screen_2FA' | 'Login_Upsell' | 'Server_Maintenance' | 'Signup_Complete' | 'Signup_Screen' | 'Studio_Splash' | 'Title_Splash' | 'Upgrade_Acct_Complete' | 'Upgrade_Acct_Prompt' | 'Upgrade_Acct_Screen' | 'Upgrade_Acct_Verified' | 'Video_Player_Active' | 'WebView_Local_Bootstrap' | 'Webview_Status' | 'Notification_Request_Prompt' | 'Notification_Request_Dialog';

export type LoginFunnelAction = 'Click' | 'End' | 'Error' | 'Launched' | 'Render' | 'Success' | 'Video_Started' | 'Video_Stuttering';

export type LoginFunnelTargets = '' | '2FA_Too_Many_Attempts' | 'Agree' | 'Allow' | 'CDNI' | 'Code of Conduct' | 'Continue_as_Guest' | 'Create' | 'Do_Not_Track' | 'Generic' | 'Go_Back' | 'Go_Play' | 'Go_Upgrade' | 'Got_It' | 'Guest' | 'Login' | 'Message' | 'Privacy Policy' | 'Retry' | 'Restart' | 'Sign_In' | 'Sign_Up' | 'Signup_With_News' | 'Signup_Without_News' | 'Submit' | 'Terms of Service' | 'Terms of Use' | 'Upgrade' | 'Upgrade_With_News' | 'Upgrade_Without_News' | 'Postlogin' | 'Not_Now' | 'Dont_Allow' | 'PII Collection';

export type DlogLoginFunnelColumns = {
  phase: LoginFunnelPhase;
  resume?: boolean;
  action: LoginFunnelAction;
  targets?: LoginFunnelTargets;
  match_id?: number;
};

/*
"columns": [
    {
        "name": "phase",
        "type": "string"
    },
    {
        "name": "resume",
        "type": "bool"
    },
    {
        "name": "action",
        "type": "string"
    },
    {
        "name": "targets",
        "type": "string"
    }
],
*/

const MAX_DLOG_COL_LENGTH = 512;

export default function useDlogLoginFunnel() {
  const dlog = useDlogEvent<DlogLoginFunnelColumns>('dlog_event_mobile_login_funnel');

  return useCallback(
    (columns: DlogLoginFunnelColumns) => {
      const truncatedColumns = Object.entries(columns).reduce<Record<string, string | boolean | number>>((accumulator, [key, value]) => {
        if (typeof value === 'string') {
          accumulator[key] = value.length > MAX_DLOG_COL_LENGTH ? value.substring(0, MAX_DLOG_COL_LENGTH) : value;
        }

        return accumulator;
      }, {}) as DlogLoginFunnelColumns;

      dlog({
        // Explicitly order the columns, because the Dlog system will explode if you don't exactly match the order of the columns... ((╬ಠิ﹏ಠิ))
        phase: truncatedColumns.phase,
        resume: truncatedColumns.resume ?? false, // For now, resume is optional to provide default, but we might change to required later
        action: truncatedColumns.action,
        targets: truncatedColumns.targets ?? '', // Ensure targets columns is always passed, since it's optional to provide
        match_id: 0,
      });
    },
    [dlog]
  );
}
